//react
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//UI
import { message, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CardElement } from "../../../../components/Common/UIElements";
import {
  ButtonPrimary,
  Button,
} from "../../../../components/Common/Button/index";
import CustomerDetailsForm from "../../../../components/Onboarding/CustomerDetailsForm/CustomerDetailsForm";

//processing
import { onboardingCustomerDetailsSchema } from "../../../../schema/onboarding-customer.schema";
import {
  useGetCustomer,
  useUpdateCustomerDetails,
} from "../../../../hooks/Onboarding/onboarding.hooks";
import useQuery from "../../../../hooks/url.hooks";

const CorpContactCustomerEditor = (props) => {
  const { operation } = props;

  const history = useHistory();

  //get customer from url
  let query = useQuery();

  const customerId = query.get("customer") ? query.get("customer") : undefined;

  const { reset, handleSubmit, control, formState, getValues } = useForm({
    mode: "onChange",
    resolver: yupResolver(onboardingCustomerDetailsSchema),
  });

  // fetch customer (HMG)
  const { data: apiCustomerData, refetch: refetchCustomerData } =
    useGetCustomer(customerId, {
      enabled: !!customerId,
    });

  //update customer
  const { mutateAsync: updateCustomerDetails } = useUpdateCustomerDetails({
    onSuccess: () => {
      refetchCustomerData();
      history.push("/onboarding/dashboard");
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  useEffect(() => {
    if (apiCustomerData) {
      reset({
        ...apiCustomerData,
      });
    }
  }, [apiCustomerData]);

  const customerDetailsEdit = async (formData) => {
    if (formData.same_billing_address) {
      formData["billing_details"] = {
        address_line_1: formData.address_line_1,
        address_line_2: formData.address_line_2,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        zip_code: formData.zip_code,
      };
    }
    await updateCustomerDetails(formData);
  };

  const clickCancel = () => {
    history.push("/onboarding/dashboard");
  };

  return (
    <>
      <CardElement title="System Discovery">
        <Row>
          <Col span={1} offset={23}>
            <div onClick={clickCancel}>
              <CloseOutlined />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CustomerDetailsForm
              control={control}
              errors={formState.errors}
              operation={operation}
              getValues={getValues}
            />
          </Col>
        </Row>
        <Row>
          <Col span={16} offset={4}>
            <div style={{ textAlign: "center" }}>
              <Button onClick={clickCancel}>Cancel</Button>
              <ButtonPrimary onClick={handleSubmit(customerDetailsEdit)}>
                Save
              </ButtonPrimary>
            </div>
          </Col>
        </Row>
      </CardElement>
    </>
  );
};

export default CorpContactCustomerEditor;
